import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const partnerUserParamsSchema = object({
  userId: stringToNumber()
})
